import { useState, useEffect } from 'react';
import { event } from '../../EventBridge';
var usePapiData = function (key) {
    var _a, _b;
    var _c = useState(), papiData = _c[0], setPapiData = _c[1];
    var papiSession = JSON.parse((_a = window.sessionStorage.getItem('papi')) !== null && _a !== void 0 ? _a : 'null');
    useEffect(function () {
        if (papiSession === null || papiSession === void 0 ? void 0 : papiSession[key]) {
            setPapiData(papiSession[key]);
        }
    }, [JSON.stringify((_b = papiSession === null || papiSession === void 0 ? void 0 : papiSession[key]) !== null && _b !== void 0 ? _b : null)]);
    if (!papiSession) {
        event.one('papiReady', function (papiReadyData) {
            if (!window.sessionStorage.getItem('papi')) {
                window.sessionStorage.setItem('papi', JSON.stringify(papiReadyData));
            }
            setPapiData(papiReadyData[key]);
        });
    }
    return papiData;
};
export default usePapiData;
//# sourceMappingURL=index.js.map